import { motion } from 'motion/react';
import { formatNumberLocale } from '@/utils/helpers/formatters';

const Annotation = ({
  position,
  label,
  value,
  index,
  decimals = 0,
  marginLeft = 0,
  unit = '',
}: {
  position: number;
  label: string;
  value: number;
  index: number;
  decimals?: number;
  marginLeft?: number;
  unit?: string;
}) => {
  //Positions low, average and high values on different sides of the dashed line
  const positionByIndex = [position - 24, position + 4, position - 10];

  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        role='separator'
        aria-orientation='horizontal'
        aria-hidden='true'
        className={'border-top border-primary/20 pointer-events-none absolute h-px border-t border-dashed print:hidden'}
        style={
          {
            top: `${position}px`,
            left: `${marginLeft}px`,
            width: `calc(100% - var(--marginLeft))`,
            '--marginLeft': `${marginLeft}px`,
          } as React.CSSProperties
        }
      />
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className='border-primary/20 text-primary/20 hover:bg-primary absolute flex cursor-pointer items-center gap-1
          rounded-full border bg-white/50 px-1.5 pt-[3px] pb-[2.5px] text-[10px] leading-[12px] backdrop-blur-xs
          transition-all duration-300 hover:text-white hover:opacity-100 print:hidden'
        style={{ top: `${positionByIndex[index]}px`, left: `${marginLeft + 4}px` }}
      >
        <span>{label}:</span>
        <span className='font-semibold'>
          {formatNumberLocale(Number(value.toFixed(decimals)))} {unit}
        </span>
      </motion.p>
    </>
  );
};

export default Annotation;
